import React, { useEffect, useState } from 'react'
import { useAppSelector } from '../../../../store/hooks'
import {
  selectCrossClientResultExecutionLoading,
  selectCrossClientResults,
  selectCrossClientResultsExecution,
} from '../../../../store/crossClient/crossClientResults'
import { ONE_DAY_IN_SECONDS, ONE_HOUR_IN_SECONDS, toTwoDigits } from '../../../../apps/professional-app/fa/common/aifeatures/utils'
import { CrossClientProgress } from '../../Progress/CrossClientProgress'
import { CrossClientClauses } from '../../Clauses/CrossClientClauses'
import { CrossClientQueryPhases } from '../../../../models/CrossClient'

export const CrossClientSidebar: React.FC = () => {
  const execution = useAppSelector(selectCrossClientResultsExecution)
  const results = useAppSelector(selectCrossClientResults)
  const executionLoading = useAppSelector(selectCrossClientResultExecutionLoading)
  const [now, setNow] = useState<Date>(new Date())

  const isRunning = execution?.phase === CrossClientQueryPhases.PROCESSING

  useEffect(() => {
    if (isRunning) {
      const interval = setInterval(() => setNow(new Date()), 1000)
      return () => {
        clearInterval(interval)
      }
    }
  }, [isRunning])

  if (executionLoading || !execution) {
    return <div className='skeleton w-100 h-25' />
  }

  const atomicClauses = execution.decomposition?.atomicClauses ?? []

  return (
    <div className='d-flex flex-column gap-3 zocks-p-2.0 zocks-bg-color-gray-100 h-100'>
      <div className='d-flex gap-3 px-3 py-4 border border-1 zocks-border-color-gray-200 zocks-border-1.0 bg-white'>
        <CrossClientProgress total={execution.clientIds.length} done={results.length} />
        <div className='d-flex flex-column gap-1 justify-content-center'>
          <div className='paragraph-medium'>
            Checked <strong>{results.length}</strong> of {execution.clientIds.length.toLocaleString()} clients
          </div>
          {isRunning ? <div className='paragraph-small zocks-text-gray-700'>Running {getDuration(execution.updatedAt, now.toISOString())}</div> : null}
        </div>
      </div>
      <div className='d-flex flex-column gap-3 px-3 py-4 border border-1 zocks-border-color-gray-200 zocks-border-1.0 bg-white'>
        <h6>Question details</h6>
        <div className='paragraph-medium'>{execution.userQuestion}</div>
        <CrossClientClauses atomicClauses={atomicClauses} />
      </div>
    </div>
  )
}

const getDuration = (start: string, end: string) => {
  const startDate = new Date(start)
  const endDate = new Date(end)
  const diffInSec = (endDate.getTime() - startDate.getTime()) / 1000
  const days = Math.floor(diffInSec / ONE_DAY_IN_SECONDS)
  const hours = Math.floor((diffInSec % ONE_DAY_IN_SECONDS) / 3600)
  const minutes = Math.floor((diffInSec % ONE_HOUR_IN_SECONDS) / 60)
  const seconds = Math.floor(diffInSec % 60)

  return `${days ? `${days}d ` : ''}${hours ? `${toTwoDigits(hours)}h ` : ''}${minutes ? `${toTwoDigits(minutes)}m ` : ''}${seconds ? `${toTwoDigits(seconds)}s ` : ''}`
}
